import {NXTPage} from "../pages/Page/NXTPage";

export function registerPageScript(condition: () => boolean, PageClass: new () => NXTPage): void {
    const bootstrap = () => {
        if (condition()) {
            const page = new PageClass();
            page.initialize();
        }
    };
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', bootstrap);
    } else {
        bootstrap();
    }
}

export function conditionBodyClass(className: string): () => boolean {
    return () => document.querySelector('body')?.classList.contains(className) ?? false;
}
